import {
  CustomInput,
  CheckInput,
  ReactSelect,
  CreatableReactSelect,
} from "../../kits/Inputs/Inputs";
import CustomButton from "../../kits/button/CustomButton";
import AddBankAccount from "./AddBankAccount";
import ColorSchema from "../../kits/Color";
import useAxios from "../../../services/useAxios";
import ToastCustomize from "../../kits/ToastCustomize";
import { useEffect, useState } from "react";
export default function BaseInfoData({
  // customerData,
  // dataHandler,
  type,
  tagOption,
  // textErr,
  // errorHandler,
  data,
  userOption,
  AddCustomer,
  EditCustomer,
  setTagUpdater,
  bankName,
}) {
  const [customerData, setCustomerData] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    companyAddress: "",
    corporate: true,
    mobile: "",
    tell: "",
    tags: [],
    main_uid: [],
    bankAccount: [],
    newFirstName: "",
    newLastName: "",
    newMobile: "",
    economical_number: "",
    identification_code: "",
    postalCode: "",
  });
  const [textErr, setTextErr] = useState({});
  const dataHandler = (name, value, id) => {
    if (name == "corporate" && value == false) {
      setCustomerData((prev) => {
        return { ...prev, [name]: value, companyName: "" };
      });
    } else if (name == "bankAccount") {
      let temp = [
        ...customerData.bankAccount,
        { ...value, index: customerData.bankAccount.length + 1 },
      ];
      setCustomerData((prev) => {
        return { ...prev, bankAccount: temp };
      });
    } else if (name == "removeAccount") {
      let temp = customerData.bankAccount.filter((c) => c.index != id);
      setCustomerData((prev) => {
        return { ...prev, bankAccount: temp };
      });
    } else {
      setCustomerData((prev) => {
        return { ...prev, [name]: value };
      });
    }
  };
  const errorHandler = (name, value) => {
    setTextErr((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const [newTagId, setNewTagId] = useState([]);
  const mobileChecker = (mobile) => {
    const mobileRgx = /^(\+98|0)( |-){0,1}\d{3}( |-){0,1}\d{3}( |-){0,1}\d{4}$/;
    return mobileRgx.test(mobile);
  };

  const validation = () => {
    let validate = true;
    if (mobileChecker(customerData.mobile)) {
      errorHandler("mobile", "");
    } else {
      errorHandler("mobile", "شماره وارد شده صحیح نیست.");
      validate = false;
    }
    if (customerData.postalCode.length == 10) {
      errorHandler("postalCode", "");
    } else {
      errorHandler("postalCode", "کدپستی باید 10 رقمی باشد.");
      validate = false;
    }
    if (customerData.corporate == true && customerData.companyName == "") {
      errorHandler("companyName", "نام شرکت را مشخص کنید !");
      validate = false;
    } else {
      errorHandler("companyName", "");
    }
    if (customerData.firstName == "") {
      errorHandler("fName", "نام را مشخص کنید !");
      validate = false;
    } else {
      errorHandler("fName", "");
    }
    if (customerData.lastName == "") {
      errorHandler("lName", "نام خانوادگی را مشخص کنید !");
      validate = false;
    } else {
      errorHandler("lName", "");
    }
    if (customerData?.main_uid?.value == -1) {
      if (customerData.newFirstName == "") {
        errorHandler("newFirstName", "فیلد را پر کنید!");
        validate = false;
      } else {
        errorHandler("newFirstName", "");
      }
      if (customerData.newLastName == "") {
        errorHandler("newLastName", "فیلد را پر کنید!");
        validate = false;
      } else {
        errorHandler("newLastName", "");
      }
      if (customerData.newMobile == "") {
        errorHandler("newMobile", "فیلد را پر کنید!");
        validate = false;
      } else if (!mobileChecker(customerData.newMobile)) {
        errorHandler("newMobile", "شماره وارد شده صحیح نیست!");
        validate = false;
      } else {
        errorHandler("newMobile", "");
      }
    }
    return validate;
  };
  const { loading, execute: addTagApi } = useAxios("api/Insert_tag");
  const addTagFunc = (title) => {
    addTagApi({ text: title, status: 1 }).then((result) => {
      console.log(result);
      if (result.status == 1) {
        ToastCustomize({
          mainText: "تگ با موفقیت اضافه شد.",
          duration: 2000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
        setTagUpdater((prev) => !prev);
        dataHandler("tags", [
          ...customerData.tags,
          { value: result.result.id, label: title },
        ]);
      } else {
        ToastCustomize({
          mainText: "مشکلی در ثبت تگ پیش آمده است.",
          duration: 2000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  };
  useEffect(() => {
    if (type == "edit")
      setCustomerData({ ...data, main_uid: data?.main_uid[0] });
  }, [data]);

  console.log("customerData base", customerData);

  return (
    <div className="d-flex flex-wrap">
      <div className="col-sm-4 col-12 px-1 my-1 d-flex flex-column">
        <label className="label-class">نوع مشتری</label>
        <div className="d-flex flex-grow-1 align-items-center">
          <CheckInput
            key={`corporate-customer-1`}
            label="حقوقی"
            type="radio"
            id={`corporate-radio-1`}
            name={`corporate-radio`}
            inputValue={customerData.corporate == false ? false : true}
            onChangeFunc={() => dataHandler("corporate", true)}
          />
          <CheckInput
            inputContainer="ms-3"
            key={`corporate-customer-2`}
            label="حقیقی"
            type="radio"
            id={`corporate-radio-2`}
            name={`corporate-radio`}
            inputValue={customerData.corporate == true ? false : true}
            onChangeFunc={() => {
              dataHandler("corporate", false);
              errorHandler("companyName", "");
            }}
          />
        </div>
      </div>
      <CustomInput
        inputContainer="col-sm-4 col-12 px-1 my-1"
        label="نام شرکت"
        inputSize="sm"
        inputValue={customerData.companyName}
        onChangeFunc={(e) => dataHandler("companyName", e.target.value)}
        activate={customerData.corporate ? "active" : "disabled"}
        textErr={textErr.companyName}
      />
      <CustomInput
        inputContainer="col-sm-4 col-12 px-1 my-1"
        label="آدرس"
        inputSize="sm"
        inputValue={customerData.companyAddress}
        onChangeFunc={(e) => dataHandler("companyAddress", e.target.value)}
        textErr={textErr.companyAddress}
      />
      <CustomInput
        inputContainer="col-sm-4 col-12 px-1 my-1"
        label="کدپستی"
        inputSize="sm"
        inputValue={customerData.postalCode}
        onChangeFunc={(e) => {
          if (!isNaN(e.target.value)) dataHandler("postalCode", e.target.value);
        }}
        textErr={textErr.postalCode}
      />
      <CustomInput
        inputContainer="col-sm-4 col-12 px-1 my-1"
        label="شماره اقتصادی"
        inputSize="sm"
        inputValue={customerData.economical_number}
        onChangeFunc={(e) => {
          if (!isNaN(e.target.value))
            dataHandler("economical_number", e.target.value);
        }}
      />
      <CustomInput
        inputContainer="col-sm-4 col-12 px-1 my-1"
        label={customerData.corporate ? "شماره ثبت" : "کدملی"}
        inputSize="sm"
        inputValue={customerData.identification_code}
        onChangeFunc={(e) => {
          if (!isNaN(e.target.value))
            dataHandler("identification_code", e.target.value);
        }}
      />
      <CustomInput
        inputContainer="col-sm-4 col-12 px-1 my-1"
        label="نام"
        inputSize="sm"
        inputValue={customerData.firstName}
        onChangeFunc={(e) => dataHandler("firstName", e.target.value)}
        textErr={textErr.fName}
      />
      <CustomInput
        inputContainer="col-sm-4 col-12 px-1 my-1"
        label=" نام خانوادگی"
        inputSize="sm"
        inputValue={customerData.lastName}
        onChangeFunc={(e) => dataHandler("lastName", e.target.value)}
        textErr={textErr.lName}
      />
      <ReactSelect
        inputContainer="col-sm-4 col-12 px-1 my-1"
        isMulti={false}
        itemsList={[
          { value: "-1", label: "ساخت کاربر جدید" },
          ...userOption?.map((value) => {
            return {
              value: value.value,
              label: `${value.label} ${
                value?.mobile != null && value?.mobile != "null"
                  ? `-${value?.mobile}`
                  : ""
              }`,
            };
          }),
        ]}
        inputSize="text"
        title="کاربر اصلی"
        inputValue={customerData.main_uid}
        onChangeFunc={(e, action) => {
          if (action.action == "select-option") dataHandler("main_uid", e);
          else if (action.action == "clear") dataHandler("main_uid", "");
        }}
        isClearable={true}
      />
      {customerData?.main_uid?.value == -1 && (
        <div
          className="shadow col-12 px-1 my-1 d-flex flex-wrap rounded border"
          style={{ backgroundColor: ColorSchema.dark_light_custom }}
        >
          {" "}
          <CustomInput
            inputContainer="col-sm-4 col-12 px-1 my-1"
            label="نام(کاربرجدید)"
            inputSize="sm"
            inputValue={customerData.newFirstName}
            onChangeFunc={(e) => dataHandler("newFirstName", e.target.value)}
            textErr={textErr.newFirstName}
          />
          <CustomInput
            inputContainer="col-sm-4 col-12 px-1 my-1"
            label=" نام خانوادگی(کاربر جدید)"
            inputSize="sm"
            inputValue={customerData.newLastName}
            onChangeFunc={(e) => dataHandler("newLastName", e.target.value)}
            textErr={textErr.newLastName}
          />
          <CustomInput
            inputContainer="col-sm-4 col-12 px-1 my-1"
            label="موبایل(کاربر جدید)"
            inputSize="sm"
            inputValue={customerData.newMobile}
            placeholder="نمونه: 09116454423"
            onChangeFunc={(e) => {
              if (isNaN(e.target.value)) {
                errorHandler("newMobile", "فقط عدد وارد کنید!");
              } else {
                dataHandler("newMobile", e.target.value);
                errorHandler("newMobile", "");
              }
            }}
            textErr={textErr.newMobile}
          />
        </div>
      )}
      <CustomInput
        inputContainer="col-sm-6 col-12 px-1 my-1"
        label="موبایل"
        inputSize="sm"
        inputValue={customerData.mobile}
        placeholder="نمونه: 09116454423"
        onChangeFunc={(e) => {
          if (isNaN(e.target.value)) {
            errorHandler("mobile", "فقط عدد وارد کنید!");
          } else {
            dataHandler("mobile", e.target.value);
            errorHandler("mobile", "");
          }
        }}
        textErr={textErr.mobile}
      />
      <CustomInput
        inputContainer="col-sm-6 col-12 px-1 my-1"
        label="تلفن"
        inputSize="sm"
        placeholder="نمونه:01743253662"
        inputValue={customerData.tell}
        onChangeFunc={(e) => {
          if (isNaN(e.target.value)) {
            errorHandler("tell", "فقط عدد وارد کنید!    ");
          } else {
            dataHandler("tell", e.target.value);
            errorHandler("tell", "");
          }
        }}
        textErr={textErr.tell}
      />
      <CreatableReactSelect
        inputContainer="col-12 px-1 my-1"
        isMulti={true}
        itemsList={tagOption}
        inputSize="lg"
        title="برچسبها"
        inputValue={customerData.tags}
        onChangeFunc={(e, action) => {
          console.log("action", action);
          if (action.action == "create-option") {
            addTagFunc(action.option.label);
          } else dataHandler("tags", e);
        }}
      />
      <div className="col-12">
        <AddBankAccount
          customerData={customerData}
          mainDataHandler={dataHandler}
          bankNameOption={bankName}
        />
      </div>

      <div className="d-flex ms-auto pe-1">
        {" "}
        <CustomButton
          onClick={() => {
            if (validation()) {
              type == "add"
                ? AddCustomer(customerData)
                : EditCustomer(customerData);
            }
          }}
          size="medium"
          color={`${type == "add" ? "success" : "primary"}`}
        >
          {type == "add" ? "ثبت نهایی" : "ویرایش"}
        </CustomButton>
      </div>
    </div>
  );
}
